import type { Directive, DirectiveBinding } from "vue";
import { hasPermission } from "@shared/utils/permission";

/** v-permission="'adminRoleDelete'"：key 不在当前用户 type=2 节点中则移除 */
export const permissionDirective: Directive<HTMLElement, string | undefined> = {
    mounted(el: HTMLElement, binding: DirectiveBinding<string | undefined>) {
        const path = binding.value;
        if (typeof path === "string" && path && !hasPermission(path)) {
            el.parentNode?.removeChild(el);
        }
    },
};
